/* eslint-disable @typescript-eslint/class-name-casing */
import * as React from 'react'
import styled from 'styled-components'
import {
  commonProps,
  CommonProps,
  typographyProps,
  TypographyProps,
  sx,
  SxProps,
  compose
} from '@bestyled/system'
import { useDefaultTextStyles } from './DefaultTextStyle'

export interface TextInputProps extends CommonProps, TypographyProps {
  placeholder: string
  onKeyPress?: Function
  onChange?: Function
  ref?: any
  as?: string
  style?: any
  itemType?: string
  contentEditable?: true
  suffix?: string
}

const TextInputStyled = styled.div.attrs<React.FC<TextInputProps>>({
  contentEditable: true
})`
  display: inline;

  &[contenteditable]:focus {
    outline: 0px solid transparent;
  }

  &[contenteditable='true']:empty:before {
    content: attr(placeholder);
    color: ${(props) => props.theme.colors['neutral-light']};
  }

  &[contenteditable='true']:focus:after {
    content: attr(data-suffix);
    color: ${(props) => props.theme.colors['neutral-dark']};
  }

  ${compose(commonProps, typographyProps)} ${sx}
` as React.FC<TextInputProps>

export const TextInput: React.FC<TextInputProps> = React.forwardRef(
  (props, ref) => {
    const defaults = useDefaultTextStyles()

    const propsWithDefaults = React.useMemo(
      () => ({
        onChange: null,
        onKeyPress: null,
        onKeyDown: props.onKeyPress,
        onInput: props.onChange,
        ...defaults,
        ...props
      }),
      [props, defaults]
    )

    return <TextInputStyled ref={ref} {...propsWithDefaults} />
  }
)
